import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PriceListState {
  isPriceListUploaded: boolean;
}

const initialState: PriceListState = {
  isPriceListUploaded: false,
};

const priceListSlice = createSlice({
  name: 'pricelist',
  initialState,
  reducers: {
    setPriceListUploaded: (state, action: PayloadAction<boolean>) => {
      state.isPriceListUploaded = action.payload;
    },
  },
});

export const { setPriceListUploaded } = priceListSlice.actions;
export default priceListSlice.reducer;
